import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "photo",
  "use": "photo-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"photo\"><defs><style>#photo .cls-1{fill:none}</style></defs><title>资源 73</title><g id=\"photo_图层_2\" data-name=\"图层 2\"><g id=\"photo_图层_1-2\" data-name=\"图层 1\"><path id=\"photo_Rectangle_41_Copy\" data-name=\"Rectangle 41 Copy\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"photo_picture\"><path id=\"photo_Shape\" d=\"M3.19 21a1.69 1.69 0 0 1-1.69-1.67V4.67A1.69 1.69 0 0 1 3.19 3h17.62a1.69 1.69 0 0 1 1.69 1.67v14.66A1.69 1.69 0 0 1 20.81 21zm0-6.68v5h17.62v-4l-3.31-1.51-3.76 2.55a.86.86 0 0 1-.47.14.82.82 0 0 1-.64-.29L7.54 9.89zm4.4-6.52a.9.9 0 0 1 .61.29l5.21 6.45 3.65-2.46a.86.86 0 0 1 .47-.14.82.82 0 0 1 .51.17l2.77 1.14V4.68H3.19v7.25L7 8.06a.87.87 0 0 1 .6-.26zm8.09 1a.68.68 0 1 1 .68.67.67.67 0 0 1-.68-.67z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/photo.svg
// module id = 5vuh
// module chunks = 6